(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joobello-r-bento"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.jb-slideshow').forEach(function (show) {
      var slides = show.querySelectorAll('.jb-slide');
      if (slides.length < 2 || reduce) return;
      var i = 0;
      var interval = parseInt(show.getAttribute('data-interval'), 10) || 4000;
      setInterval(function () {
        slides[i].classList.remove('active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('active');
      }, interval);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joobello-r-promises"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const items = document.querySelectorAll('.promise-item');
    const dots  = document.querySelectorAll('#promiseDots [data-dot]');
    if (!items.length) return;
    let idx = 0;
    function show(next) {
      items.forEach((el, i) => {
        el.classList.remove('active');
        if (i === idx && next !== idx) el.classList.add('exiting');
        else el.classList.remove('exiting');
      });
      idx = next;
      items[idx].classList.add('active');
      dots.forEach((d, i) => {
        const inner = d.querySelector('span');
        if (!inner) return;
        inner.classList.toggle('bg-white', i === idx);
        inner.classList.toggle('bg-white/30', i !== idx);
      });
    }
    let timer = setInterval(() => show((idx + 1) % items.length), 3200);
    dots.forEach((d, i) => d.addEventListener('click', () => { clearInterval(timer); show(i); timer = setInterval(() => show((idx + 1) % items.length), 3200); }));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joobello-r-quiz"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const card = document.getElementById('quizCard');
    if (!card) return;
    const steps = card.querySelectorAll('.quiz-step');
    const bar = document.getElementById('quizBar');
    const restart = document.getElementById('quizRestart');
    const resultsEl = document.getElementById('quizResults');
    const titleEl = document.getElementById('quizResultTitle');
    const blurbEl = document.getElementById('quizResultBlurb');

    const PRODUCTS = {
      'airtag':  { name: 'AirTag GPS Dog Collar', price: '$24.10', was: '$39.99', tone: 'navy' },
      'bed':     { name: 'Calming Donut Bed',     price: '$34.99', was: '$54.99', tone: 'orange' },
      'arch':    { name: 'Cat Self-Grooming Arch', price: '$19.99', was: '$34.99', tone: 'cream' },
      'feeder':  { name: 'Smart Auto Pet Feeder', price: '$79.99', was: '$129.99', tone: 'navy' },
      'water':   { name: 'Walking Water Bottle',  price: '$22.99', was: '$34.99', tone: 'orange' },
    };
    const MAP = {
      'dog-escape':   ['airtag','water','bed'],
      'dog-destroy':  ['bed','feeder','airtag'],
      'dog-drink':    ['water','feeder','airtag'],
      'dog-shed':     ['bed','water','airtag'],
      'dog-anxiety':  ['bed','water','feeder'],
      'dog-feeding':  ['feeder','water','bed'],
      'cat-escape':   ['airtag','bed','arch'],
      'cat-destroy':  ['arch','bed','feeder'],
      'cat-drink':    ['feeder','water','arch'],
      'cat-shed':     ['arch','bed','water'],
      'cat-anxiety':  ['bed','feeder','arch'],
      'cat-feeding':  ['feeder','arch','bed'],
      'all-escape':   ['airtag','bed','water'],
      'all-destroy':  ['bed','arch','feeder'],
      'all-drink':    ['water','feeder','arch'],
      'all-shed':     ['arch','bed','water'],
      'all-anxiety':  ['bed','feeder','arch'],
      'all-feeding':  ['feeder','water','arch'],
    };
    const TITLES = {
      escape:   "Three things that stop the great escape.",
      destroy:  "Three things that channel the chaos.",
      drink:    "Three things that fix the water problem.",
      shed:     "Three things that take the hair down.",
      anxiety:  "Three things that calm them down.",
      feeding:  "Three things that handle dinner without you.",
    };

    let state = { pet: null, problem: null };

    function go(stepNum) {
      steps.forEach(s => s.classList.toggle('active', s.dataset.step === String(stepNum)));
      bar.style.width = (stepNum === 1 ? 33 : stepNum === 2 ? 66 : 100) + '%';
    }

    function render() {
      if (state.pet === 'small') {
        titleEl.textContent = "Small pet gear is coming Q3.";
        blurbEl.textContent = "Sign up below — we'll let you know the second it lands. No spam.";
        resultsEl.innerHTML = '<a href="#joobello-email" onclick="var i=document.querySelector(\'input[type=email]\'); if(i){i.focus(); i.scrollIntoView({block:\'center\'});} event.preventDefault();" class="sm:col-span-3 quiz-opt text-center" style="background:#1A2B4C;color:white;border-color:#1A2B4C">Join the small-pet waitlist →</a>';
        return;
      }
      const key = state.pet + '-' + state.problem;
      const slugs = MAP[key] || ['water','airtag','bed'];
      titleEl.textContent = TITLES[state.problem] || "Three things that fix this.";
      blurbEl.textContent = "Picked from what's in stock right now. No fluff.";
      resultsEl.innerHTML = slugs.map(s => {
        const p = PRODUCTS[s];
        const bg = p.tone === 'navy' ? 'linear-gradient(135deg,#1A2B4C,#2a3f6a)' : p.tone === 'orange' ? 'linear-gradient(135deg,#FF6B35,#ff8a5a)' : 'linear-gradient(135deg,#FFF5E8,#F4EFE6)';
        const fg = p.tone === 'cream' ? '#1A2B4C' : '#FFFFFF';
        return `<div class="prod-tile" style="transform:rotate(0deg)">
          <div class="aspect-[4/3] flex items-center justify-center" style="background:${bg}">
            <div class="font-display text-[24px] leading-[0.9] text-center px-3" style="color:${fg}; opacity:0.92">${p.name.split(' ').slice(0,2).join('<br/>')}</div>
          </div>
          <div class="p-5">
            <h4 class="font-display text-[18px] leading-tight text-navy">${p.name}</h4>
            <div class="mt-3 flex items-center justify-between">
              <div><span class="font-display text-[20px] text-navy">${p.price}</span> <span class="text-[12px] text-navy/40 line-through ml-1">${p.was}</span></div>
              <button class="bg-navy text-white rounded-full px-3 py-1.5 text-[12px] font-extrabold relative" data-atc>Add →<svg class="paw-stamp-overlay" aria-hidden="true"><use href="#check"/></svg></button>
            </div>
          </div>
        </div>`;
      }).join('');
      resultsEl.querySelectorAll('[data-atc]').forEach(btn => btn.addEventListener('click', window.joobelloPawStamp));
    }

    card.querySelectorAll('[data-pet]').forEach(b => b.addEventListener('click', () => {
      card.querySelectorAll('[data-pet]').forEach(x => x.classList.remove('selected'));
      b.classList.add('selected');
      state.pet = b.dataset.pet;
      setTimeout(() => go(2), 280);
    }));
    card.querySelectorAll('[data-problem]').forEach(b => b.addEventListener('click', () => {
      card.querySelectorAll('[data-problem]').forEach(x => x.classList.remove('selected'));
      b.classList.add('selected');
      state.problem = b.dataset.problem;
      setTimeout(() => { render(); go(3); }, 280);
    }));
    restart.addEventListener('click', () => {
      state = { pet: null, problem: null };
      card.querySelectorAll('.quiz-opt').forEach(x => x.classList.remove('selected'));
      go(1);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
